import {Dialog, Box, Typography, IconButton} from '@mui/material';
import SecondaryButton from '../Reusable/SecondaryButton/SecondaryButton';
import CloseIcon from '@mui/icons-material/Close';
import ReusableButton from '../Reusable/PrimaryButton/PrimaryButton';

const ConfirmationButton = ({
  open,
    handleClose,
    handleConfirm,
    title,
    Description
}:any) =>{
    return(
           <Dialog
                    open={open}
                    className='PopupContainer'
                    onClose={() => handleClose()}
                    >
                        <Box>
                            <Box className="PopupHeader">
                                    <IconButton onClick={handleClose} className="PopupCloseButton">
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                            <Typography variant="h6"  className='confirmTitle' gutterBottom>
                                {title}
                            </Typography>
                            <Typography className='confirmDescription' gutterBottom>
                                {Description}
                            </Typography>
                            <Box className='cofimationButton'>
                                
                                <SecondaryButton
                                    variant="outlined"
                                    onClick={() => {
                                        handleClose();
                                    }}
                                >
                                    Cancel
                                </SecondaryButton>
                                <ReusableButton
                                    variant="contained"
                                    color="error"
                                    onClick={() => {
                                        handleConfirm();
                                        handleClose();
                                    }}
                                >
                                    Delete
                                </ReusableButton>
                            </Box>
                        </Box>
                    </Dialog>
    )
}
export default ConfirmationButton;